import { combineReducers } from "redux";

//#region layout
import Layout from "./layouts/reducer";
//#endregion

//#region
import Login from "./auth/login/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import ResetPassword from "./auth/resetPassword/reducer";
//#endregion

//#region profile
import Profile from "./auth/profile/reducer";
//#endregion

//#region customers
import Customers from "./users/customers/reducer";
//#endregion

//#region technicians
import Technicians from "./users/technicians/reducer";
//#endregion

//#region categories
import Categories from "./services/categories/reducer";
//#endregion

//#region services
import Services from "./services/services/reducer";
//#endregion

//#region governorates
import Governorates from "./locations/governorates/reducer";
//#endregion

//#region cities
import Cities from "./locations/cities/reducer";
//#endregion

//#region notification
import Notifications from "./notification/reducer";
//#endregion

//#region ads
import Ads from "./ads/reducer";
//#endregion

//#region complains
import Complains from "./complains/reducer";
//#endregion

//#region orders
import Orders from "./orders/reducer";
//#endregion

//#region policies
import Policies from "./policies/reducer";
//#endregion

//#region settings
import Settings from "./settings/reducer";
//#endregion

//#region dashboard
import Dashboard from "./dashboard/reducer";
//#endregion

//#region subscriptions
import Subscriptions from "./plans/subscriptions/reducer";
//#endregion

const rootReducer = combineReducers({
  Layout,
  Login,
  ForgetPassword,
  ResetPassword,
  Profile,
  Customers,
  Technicians,
  Categories,
  Services,
  Governorates,
  Cities,
  Notifications,
  Ads,
  Complains,
  Orders,
  Policies,
  Settings,
  Dashboard,
  Subscriptions,
});

export default rootReducer;
